export default "__VITE_ASSET__B__XSAJ2__"